/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'live': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M11.667 10c0 .917-.75 1.667-1.667 1.667S8.333 10.917 8.333 10 9.083 8.333 10 8.333s1.667.75 1.667 1.667Zm-4.6-2.958-.592-.584A4.98 4.98 0 0 0 5 10a4.98 4.98 0 0 0 1.475 3.542l.592-.592A4.135 4.135 0 0 1 5.833 10c0-1.158.475-2.2 1.234-2.958Zm6.458-.584-.592.592A4.135 4.135 0 0 1 14.167 10a4.17 4.17 0 0 1-1.234 2.958l.592.592A5.015 5.015 0 0 0 15 10a4.98 4.98 0 0 0-1.475-3.542ZM4.708 4.692 4.125 4.1a8.307 8.307 0 0 0 0 11.8l.592-.592A7.461 7.461 0 0 1 2.5 10c0-2.075.85-3.95 2.208-5.308ZM15.875 4.1l-.592.592A7.462 7.462 0 0 1 17.5 10c0 2.075-.85 3.95-2.208 5.308l.591.592a8.334 8.334 0 0 0 2.45-5.9c0-2.3-.941-4.392-2.458-5.9Z" _fill="#fff" _stroke="#fff" stroke-width=".5"/>'
  }
})
